import React, { useState, useEffect } from "react";
import {
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import * as url from "../../utils/urls";
import { apiReq } from "../../utils/utils";
import { useSelector } from "react-redux";
import { Table } from "antd";
import { useForm } from "react-hook-form";
import moment from "moment";
import Swal from "sweetalert2";
import generator from "generate-password";
import Loading from "../../components/Common/Loading";

function StaffList(props) {
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const user = useSelector((state) => state.User);
  const [isShowPassword, setIsShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    if (user?.user?.role?.title !== "Admin") {
      props.history.push("/dashboard");
    }
  }, []);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm();

  console.log("selectedItem", selectedItem);

  // get users
  const getUsers = () => {
    setIsLoading(true);
    apiReq(url.GET_USERS, {}, "get", {
      Authorization: `Bearer ${user.user?.token}`,
    })
      .then((res) => {
        if (res.success && res.data !== null) {
          setUsers(res.data);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err>>>", err);
      });
  };

  // GET Roles
  const getRoles = () => {
    setIsLoading(true);
    apiReq(url.GET_ROLE, {}, "get", {})
      .then((res) => {
        if (res.success) {
          setRoles(res.data);
        }
      })
      .catch((err) => {
        console.log("err>>>", err);
      });
  };

  useEffect(() => {
    getRoles();
    getUsers();
  }, []);

  // Toggle modal
  const toggleModal = () => {
    setIsOpenModal(!isOpenModal);
  };

  // TODO: columns
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      sorter: (a, b) => a.email.localeCompare(b.email),
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Mobile",
      dataIndex: "mobile",
      key: "mobile",
      sorter: (a, b) => a.mobile.localeCompare(b.mobile),
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Role",
      render: (text, record, index) => (
        <span>{record.role ? record.role.title : "NA"}</span>
      ),
    },
    {
      title: "Date",
      sorter: (a, b) => a.createdAt.localeCompare(b.createdAt),
      render: (text, record, index) => (
        <span style={{ whiteSpace: "nowrap" }}>
          {moment(record.createdAt).format("DD-MM-YYYY hh:mm A")}
        </span>
      ),
    },
    {
      title: "Action",
      render: (text, record, index) => (
        <div className="d-flex">
          {/* <button
            className="btn btn-success btn-sm mr-2"
            onClick={() => handleEdit(record)}
          >
            <i className="ri-pencil-line"></i>
          </button>
          &nbsp;&nbsp;&nbsp;&nbsp; */}
          {user?.user?.role.title === "Admin" && (
            <>
              {user.user?._id !== record._id ? (
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => handleDelete(record._id)}
                >
                  <i className="ri-delete-bin-line"></i>
                </button>
              ) : (
                <button
                  className="btn btn-danger btn-sm"
                  style={{ opacity: 0.5 }}
                  onClick={() => {
                    Swal.fire({
                      title: "Oops...",
                      text: "You can not delete your own account",
                      icon: "error",
                      showConfirmButton: false,
                      timer: 1500,
                    });
                  }}
                >
                  <i className="ri-delete-bin-line"></i>
                </button>
              )}
            </>
          )}
        </div>
      ),
    },
  ];

  // Todo: handleDelete
  const handleDelete = (id) => {
    Swal.fire({
      title: "<Strong>Are you absolutely sure?</Strong>",
      html: "Please type <Strong>DELETE</Strong> to confirm.",
      input: "text",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value === "DELETE") {
          apiReq(url.DELETE_STAFF + id, {}, "delete", {
            Authorization: `Bearer ${user.user?.token}`,
          })
            .then((res) => {
              if (res.success) {
                Swal.fire({
                  title: "Deleted!",
                  text: res.message,
                  icon: "success",
                  showConfirmButton: false,
                  timer: 1500,
                });
                getUsers();
              }
            })
            .catch((err) => {
              console.log("err>>>", err);
            });
        } else {
          Swal.fire({
            title: "Cancelled",
            text: "Your data is safe :)",
            icon: "error",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      }
    });
  };

  // Todo: onSubmit
  const onSubmit = (data) => {
    if (selectedItem === null) {
      setIsLoading(true);
      apiReq(
        url.CREATE_STAFF,
        {
          name: data.name,
          email: data.email,
          password: data.password,
          mobile: data.mobile,
          role: data.role,
        },
        "post",
        {
          Authorization: `Bearer ${user.user?.token}`,
        }
      )
        .then((res) => {
          if (res.success && res.data !== null) {
            getUsers();
            setIsOpenModal(false);
            setSelectedItem(null);
            setIsLoading(false);
            reset();
            Swal.fire({
              title: "Success",
              text: res.message,
              icon: "success",
              showConfirmButton: false,
              timer: 1500,
            });
          }
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("err>>>", err);
        });
    }
  };

  const generatePassword = () => {
    var password = generator.generate({
      length: 16,
      numbers: true,
      symbols: true,
      lowercase: true,
      uppercase: true,
    });
    setValue("password", password);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        {isLoading && <Loading />}
        <Modal toggle={toggleModal} isOpen={isOpenModal} size="lg">
          <ModalHeader>
            {selectedItem !== null ? "Update staff details" : "Add new staff"}
          </ModalHeader>
          <ModalBody>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="mb-3">
                <label>Full Name</label>
                <input
                  type="text"
                  className="form-control"
                  {...register("name", { required: true })}
                />
                {errors.name && (
                  <span className="text-danger">Name is required</span>
                )}
              </div>
              <div className="mb-3">
                <label>Email</label>
                <input
                  type="email"
                  className="form-control"
                  {...register("email", {
                    required: "Email is required.",
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: "invalid email address",
                    },
                  })}
                />
                {errors.email && (
                  <span className="text-danger">{errors.email.message}</span>
                )}
              </div>
              <div className="mb-3">
                <label>Password</label>
                <div className="row">
                  <div className="col-md-8">
                    <div
                      className="password_wrapp"
                      style={{ position: "relative" }}
                    >
                      <input
                        type={!isShowPassword ? "password" : "text"}
                        className="form-control"
                        {...register("password", {
                          required: "password is required.",
                          minLength: {
                            value: 8,
                            message: "Password must have at least 8 characters",
                          },
                          pattern: {
                            value:
                              /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,}/,
                            message:
                              "Please use atleast 1 special character, and 1 capital letter in the password.",
                          },
                        })}
                      />
                      <span
                        style={{
                          position: "absolute",
                          right: 10,
                          top: 6,
                          fontSize: 20,
                        }}
                        onClick={() => setIsShowPassword(!isShowPassword)}
                      >
                        {isShowPassword ? (
                          <i className="ri-eye-off-line"></i>
                        ) : (
                          <i className="ri-eye-line"></i>
                        )}
                      </span>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <button
                      className="btn btn-primary w-100"
                      type="button"
                      onClick={generatePassword}
                    >
                      <i className="ri-magic-line"></i> Generate Password
                    </button>
                  </div>
                </div>
                {errors.password && (
                  <span className="text-danger">{errors.password.message}</span>
                )}
              </div>
              <div className="mb-3">
                <label>Mobile</label>
                <input
                  type="text"
                  className="form-control"
                  {...register("mobile", {
                    required: "Mobile is required",
                    valueAsNumber: true,
                    pattern: {
                      value: /^(0|[1-9]\d*)(\.\d+)?$/,
                    },
                    min: {
                      value: 10,
                      message: "Mobile number must be 10 digits",
                    },
                  })}
                />
                {errors.mobile && (
                  <span className="text-danger">{errors.mobile.message}</span>
                )}
              </div>
              {roles.length > 0 && (
                <div className="mb-3">
                  <label>Role</label>
                  <div style={{ position: "relative" }}>
                    <select
                      className="form-control"
                      {...register("role", { required: true })}
                    >
                      <option value="">Select Role</option>
                      {roles.map((role) => (
                        <option key={role._id} value={role._id}>
                          {role.title}
                        </option>
                      ))}
                    </select>
                    <span
                      className="sp_dd_icon"
                      style={{
                        position: "absolute",
                        right: 10,
                        top: 8,
                        fontSize: 18,
                      }}
                    >
                      <i className="ri-arrow-down-s-line"></i>
                    </span>
                  </div>

                  {errors.role && (
                    <span className="text-danger">Role is required</span>
                  )}
                </div>
              )}

              <ModalFooter>
                <button
                  className="btn btn-secondary"
                  type="button"
                  onClick={toggleModal}
                >
                  Cancel
                </button>
                <button className="btn btn-primary" type="submit">
                  Save
                </button>
              </ModalFooter>
            </form>
          </ModalBody>
        </Modal>
        <Container fluid>
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <h5 className="card-title">Staff</h5>
                </div>
                <div className="col-md-6">
                  <div className="d-flex justify-content-end">
                    {user?.user?.role.title === "Admin" && (
                      <button
                        className="btn btn-primary"
                        onClick={() => setIsOpenModal(!isOpenModal)}
                      >
                        Add new staff
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <hr />
              <Table
                columns={columns}
                dataSource={users}
                bordered
                loading={isLoading}
              />
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default StaffList;
